/**
 * Upload System Configuration
 *
 * Toggle between old and new upload systems by changing USE_NEW_UPLOAD_SYSTEM
 */

export const UPLOAD_CONFIG = {
  // Feature flag: Set to true to use new upload system, false for legacy
  USE_NEW_UPLOAD_SYSTEM: true,

  // SECURITY: Set to true to use secure upload with presigned URLs (no AWS credentials in client)
  // This removes exposed AWS credentials and uses uploader.projector.app service
  // Default: false (will be enabled after testing)
  USE_SECURE_UPLOAD_MODE: true,

  // Upload settings
  CHUNK_SIZE: 5 * 1024 * 1024, // 5MB minimum for S3 multipart
  MAX_CONCURRENT_UPLOADS: 3,
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 2000, // 2 seconds
  // Stall watchdog: if a part upload transfers no bytes for this long, treat
  // the connection as dead and abort so the retry/network logic can recover.
  // This is what unsticks uploads after the device sleeps/locks or drops off
  // Wi-Fi mid-part (the underlying XHR otherwise hangs forever with no error).
  // Reset on every progress event, so it never fires on a slow-but-alive link.
  PART_STALL_TIMEOUT: 25000, // 25 seconds with zero bytes moved

  // Progress update settings
  PROGRESS_UPDATE_INTERVAL: 200, // Update UI every 200ms for smooth progress (in milliseconds)
  SPEED_UPDATE_INTERVAL: 1500, // Update speed/ETA every 1.5 seconds for stable display (in milliseconds)

  // Network detection
  NETWORK_CHECK_INTERVAL: 5000, // 5 seconds
  NETWORK_CHECK_URL: 'https://www.google.com/favicon.ico',

  // UI settings
  SHOW_UPLOAD_PANEL: true,
  PANEL_POSITION: 'bottom-right', // 'bottom-right', 'bottom-left', 'top-right', 'top-left'
  AUTO_HIDE_COMPLETED: true,
  AUTO_HIDE_DELAY: 5000, // 5 seconds
};

export default UPLOAD_CONFIG;
